// src/domains/auth/utils/cookies.ts

import Cookies from 'js-cookie';

export const getCookieDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return undefined;
  }
  /* eslint-disable no-console */
  console.log('Hostname:', hostname);
  return hostname;
};

export const setCookie = (name: string, value: string, days = 1) => {
  const domain = getCookieDomain();
  Cookies.set(name, value, {
    expires: days,
    secure: true,
    domain: domain,
    sameSite: 'strict',
  });
};

export const getCookie = (name: string): string | undefined => {
  return Cookies.get(name);
};

export const removeCookie = (name: string) => {
  const domain = getCookieDomain();
  Cookies.remove(name, { domain: domain });
};
